export const prefix = [
  { name: "นาย", value: "นาย" },
  { name: "นาง", value: "นาง" },
  { name: "นางสาว", value: "นางสาว" },
];

export const gender = [
  { name: "ชาย", value: "male" },
  { name: "หญิง", value: "female" },
];

export const medicalTypeList = [
  {
    name: "แพทยสภา",
    value: "แพทยสภา",
  },
  {
    name: "สภาเทคนิคการแพทย์",
    value: "สภาเทคนิคการแพทย์",
  },
  {
    name: "สภาเภสัชกรรม",
    value: "สภาเภสัชกรรม",
  },
  {
    name: "ทันตแพทยสภา",
    value: "ทันตแพทยสภา",
  },
];

export const formatThaiID = (id) => {
  if (!id) {
    return "";
  }
  
  const cleanID = String(id).replace(/[^0-9]/g, "");
  const parts = [];
  
  if (cleanID.length > 0) parts.push(cleanID.substring(0, 1));
  if (cleanID.length > 1) parts.push(cleanID.substring(1, 5));
  if (cleanID.length > 5) parts.push(cleanID.substring(5, 10));
  if (cleanID.length > 10) parts.push(cleanID.substring(10, 12));
  if (cleanID.length > 12) parts.push(cleanID.substring(12, 13));
  
  return parts.join("-");
};


export const formatBackThaiID = (id) => {
  if (!id) {
    return "";
  }

  const cleanID = id.replace(/[^a-zA-Z0-9]/g, "");
  const parts = [];
  if (cleanID.length > 0) parts.push(cleanID.substring(0, 3));
  if (cleanID.length > 3) parts.push(cleanID.substring(3, 10));
  if (cleanID.length > 10) parts.push(cleanID.substring(10, 12));
  return parts.join("-");
};

export const type_user = [
  // { name: "ประชาชนทั่วไป", value: "PATIENT" },
  { name: "แพทย์/เภสัช", value: "MEDICAL_PERSONNEL" },
  { name: "ผู้ดูแลห้องปฏิบัติการ", value: "LABORATORY_ADMIN" },
  { name: "ผู้ปฏิบัติการในห้องปฏิบัติการ", value: "LABORATORY_PERSONNEL" },
  { name: "เจ้าหน้าที่โรงพยาบาล", value: "HOSPITAL_PERSONNEL" },
  { name: "ผู้บริหาร", value: "EXECUTIVE" },
  { name: "โรงพยาบาล", value: "HOSPITAL" },
  { name: "ผู้ดูแลระบบ/แอดมิน", value: "ADMIN" },
  { name: "ประชาชน", value: "PATIENT" },
];

export const type_user_edit = [
  // { name: "ประชาชนทั่วไป", value: "PATIENT" },
  { name: "แพทย์/เภสัช", value: "MEDICAL_PERSONNEL" },
  { name: "ผู้ดูแลห้องปฏิบัติการ", value: "LABORATORY_ADMIN" },
  { name: "ผู้ปฏิบัติการในห้องปฏิบัติการ", value: "LABORATORY_PERSONNEL" },
  { name: "เจ้าหน้าที่โรงพยาบาล", value: "HOSPITAL_PERSONNEL" },
  { name: "ผู้บริหาร", value: "EXECUTIVE" },
  { name: "โรงพยาบาล", value: "HOSPITAL" },
  { name: "ผู้ดูแลระบบ/แอดมิน", value: "ADMIN" },
  { name: "ประชาชน", value: "PATIENT" },
];

// validate
export const validateRole = (data) => {
  if (!data["role"]) {
    return "กรุณาเลือกประเภทของผู้ใช้งาน";
  }
};

export const validateInformation = (data) => {
  if (!data["prefix"]) {
    return "กรุณาเลือกคำนำหน้า";
  } else if (!data["firstName"]) {
    return "กรุณากรอกชื่อ";
  } else if (!data["lastName"]) {
    return "กรุณากรอกนามสกุล";
  } else if (!data["id_card"] || data["id_card"].length !== 13) {
    return "กรุณากรอกเลขบัตรประจำตัวประชาชนให้ครบ 13 หลัก";
  } else if (!data["laser"]) {
    return "กรุณากรอกเลขหลังบัตรประจำตัวประชาชน";
  } else if (!data["gender"]) {
    return "กรุณาเลือกเพศ";
  } else if (!data["birthday"]) {
    return "กรุณาเลือกวัน/เดือน/ปีเกิด";
  }
};

export const validateLicense = (data) => {
  if (!data["licenses"]) {
    return "กรุณากรอกใบประกอบวิชาชีพ";
  }
  for (let role in data["licenses"]) {
    const license = data["licenses"][role];
    if (!license.medicalType) {
      return `กรุณากรอกประเภทวิชาชีพสำหรับ ${role}`;
    }
    if (!license.licenseNumber) {
      return `กรุณากรอกเลขใบประกอบวิชาชีพสำหรับ ${role}`;
    }
  }
};

export const validateHospital = (data) => {
  if (!data["hospital_id"]) {
    return "กรุณาเลือกโรงพยาบาล";
  }
};

export const validateAddress = (data) => {
  if (!data["zip_code"]) {
    return "กรุณากรอกรหัสไปรษณีย์";
  } else if (!data["phone"] || data["phone"].length !== 10) {
    return "กรุณากรอกเบอร์โทร";
  } else if (!data["email"]) {
    return "กรุณากรอก Email";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data["email"])) {
    return "กรุณากรอก Email ให้ถูกต้อง";
  }
};

export const validateAccount = (data) => {
  if (!data["username"]) {
    return "กรุณากรอกชื่อผู้ใช้";
  } else if (!data["password"]) {
    return "กรุณากรอกรหัสผ่าน";
  } else if (!data["confirm_password"]) {
    return "กรุณายืนยันรหัสผ่าน";
  } else if (data["password"] !== data["confirm_password"]) {
    return "รหัสผ่านและยืนยันรหัสผ่านไม่ตรงกัน";
  } else if (!/(?=.*[A-Za-z])(?=.*\d)/.test(data["password"])) {
    return "รหัสผ่านต้องประกอบด้วยตัวอักษรและตัวเลขอย่างน้อยหนึ่งตัว";
  }
};

export const validateLaboratorySelect = (data) => {
  if (!data["laboratory_id"]) {
    return "กรุณาเลือกห้องปฏิบัติการที่สังกัด";
  }
};

export const validateLaboratory = (data) => {
  if (!data["laboratory_name"]) {
    return "กรุณาตั้งชื่อห้องปฏิบัติการ";
  } else if (!data["laboratory_address"]) {
    return "กรุณากรอกที่อยู่ห้องปฏิบัติการ";
  } else if (!data["laboratory_moo"]) {
    return "กรุณากรอกหมู่ที่";
  } else if (!data["laboratory_soy"]) {
    return "กรุณากรอกซอย";
  } else if (!data["laboratory_road"]) {
    return "กรุณากรอกถนน";
  } else if (!data["laboratory_provinceId"]) {
    return "กรุณาเลือกจังหวัด";
  } else if (!data["laboratory_district"]) {
    return "กรุณากรอกอำเภอ";
  } else if (!data["laboratory_subDistrict"]) {
    return "กรุณากรอกตำบล";
  } else if (!data["laboratory_postCode"]) {
    return "กรุณากรอกรหัสไปรษณีย์";
  } else if (!data["latitude"]) {
    return "กรุณากรอกละติจูด";
  } else if (!data["longitude"]) {
    return "กรุณากรอกลองจิจูด";
  }
};

export const validatePetition = (data) => {
  if (!data.petition) {
    return "ข้อมูลคำร้องขาดหาย";
  }
  if (data.petition.LABORATORY_ADMIN) {
    const { analyst, approver, attachFile } = data.petition.LABORATORY_ADMIN;
    if (!analyst && !approver) {
      return "กรุณาเลือกหน้าที่ (ผู้วิเคราะห์ หรือ ผู้รับรองผล)";
    } else if (!attachFile) {
      return "กรุณาแนบไฟล์คำร้อง";
    }
  }

  if (data.petition.LABORATORY_PERSONNEL) {
    const { analyst, approver, attachFile } =
      data.petition.LABORATORY_PERSONNEL;
    if (!analyst && !approver) {
      return "กรุณาเลือกหน้าที่ (ผู้วิเคราะห์ หรือ ผู้รับรองผล)";
    } else if (!attachFile) {
      return "กรุณาแนบไฟล์คำร้อง";
    }
  }
};
